// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1n7As","footer":"ModalInfo_footer__2GgQb"};